import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import Home from './pages/Home';
import Login from './pages/Login';
import FullImage from './pages/FullImage';
import Cart from './pages/Cart';
import Address from './pages/Address';
import Account from './pages/Account';
import Products from './pages/Products';
import AccountMob from './mobileViewPages/AccountMob';
import MyInfo from './components/MyInfo';
import MyOrders from './components/MyOrders';
import Wishlist from './components/Wishlist';
import OrderSummary from './pages/OrderSummary';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import SearchPage from './pages/SearchPage';
import SubCatProducts from './pages/SubCatProducts';
import ImageUpload from './adminSide/ImageUpload';
import Signup from './pages/Signup';
import Verify from './pages/Verify';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserFromStorage } from './redux/Slices/UserSlice';
import ForgotPass from './pages/ForgotPass';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import OfferUpdate from './adminSide/OfferUpdate';
import AboutUs from './pages/AboutUs';
import ShippingPolicy from './pages/ShippingPolicy';
import Returns from './pages/Returns';
import SubCategoryAdd from './adminSide/SubCategoryAdd';
import UpdateColors from './pages/UpdateColors';

import ProtectedRoute from './ProtectedRoute';
import ProtectedFullImage from './ProtectedFullImage';
import UpdateProducts from './adminSide/UpdateProducts';
import ManageProducts from './adminSide/ManageProducts';
import Charts from './adminSide/Charts';
import DelhiveryTrackingComponent from './pages/DelhiveryTrackingComponent';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  const dispatch = useDispatch();
  const loginId = useSelector((state) => state.user.id);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  useEffect(() => {
    dispatch(loadUserFromStorage());
  }, [dispatch]);

  const admin = useSelector((state) => state.user.admin);


  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path='/' element={<Home />} />
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/verify' element={<Verify />} />
          <Route path='/forgotpass' element={<ForgotPass />} />
          <Route path='/privacypolicy' element={<PrivacyPolicy />} />
          <Route path='/termsconditions' element={<TermsConditions />} />
          <Route path='/aboutus' element={<AboutUs />} />
          <Route path='/shippingpolicy' element={<ShippingPolicy />} />
          <Route path='/returnpolicy' element={<Returns />} />
          <Route path='/contact' element={<Contact />} />

          {/* Protected Routes */}
          <Route path='/fullimage' element={
            // <ProtectedRoute>
            <FullImage />
            // </ProtectedRoute>
          } />

          <Route path="/:enc" element={<ProtectedFullImage />} />


          <Route path='/cart' element={<Cart />} />

          <Route path='/address' element={
            <ProtectedRoute><Address /></ProtectedRoute>
          } />

          <Route path='/account' element={
            <ProtectedRoute>{isMobile ? <AccountMob /> : <Account />}</ProtectedRoute>
          } />

          <Route path='/accountmob' element={<Navigate to="/account" replace />} />

          <Route path='/products' element={
            // <ProtectedRoute>
            <Products />
            // </ProtectedRoute>
          } />

          <Route path='/myinfo' element={
            <ProtectedRoute><MyInfo /></ProtectedRoute>
          } />

          <Route path='/myorders' element={
            <ProtectedRoute><MyOrders /></ProtectedRoute>
          } />

          <Route path='/wishlist' element={
            <ProtectedRoute><Wishlist /></ProtectedRoute>
          } />

          <Route path='/ordersummary' element={
            <ProtectedRoute><OrderSummary /></ProtectedRoute>
          } />

          <Route path='/delhiverytracking' element={
            // <ProtectedRoute>
              <DelhiveryTrackingComponent />
            // </ProtectedRoute>
          } />

          <Route path='/searchpage' element={
            // <ProtectedRoute>
            <SearchPage />
            // </ProtectedRoute>
          } />

          <Route path='/subcategoryproducts' element={
            // <ProtectedRoute>
            <SubCatProducts />
            // </ProtectedRoute>
          } />


          {admin === '1' && (
            <Route path='/imageupload' element={
              <ProtectedRoute><ImageUpload /></ProtectedRoute>
            } />
          )}

          {admin === '1' && (
            <Route path='/dashboard' element={
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            } />
          )}

          {/* {admin === '1' && (
            <Route path='/offerupdate' element={
              <ProtectedRoute><OfferUpdate /></ProtectedRoute>
            } />
          )} */}

          {admin === '1' && (
            <Route path='/subcategoryadd' element={
              <ProtectedRoute><SubCategoryAdd /></ProtectedRoute>
            } />
          )}

          {admin === '1' && (
            <Route path='/updateColors' element={
              <ProtectedRoute><UpdateColors /></ProtectedRoute>
            } />
          )}

          {/* {admin === '1' && (
            <Route path='/updateProducts' element={
              <ProtectedRoute><UpdateProducts /></ProtectedRoute>
            } />
          )} */}

          {admin === '1' && (
            <Route path='/manageProducts' element={
              <ProtectedRoute><ManageProducts /></ProtectedRoute>
            } />
          )}

          {admin === '1' && (
            <Route path='/charts' element={
              <ProtectedRoute><Charts /></ProtectedRoute>
            } />
          )}

        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
